<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Ordens vindas do Exchange</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">Confira os boletos em fila de processamento automático.</p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="list-actions">
            <div *ngIf="!loading" class="d-flex col-md-12 header justify-content-between align-items-center">
              <span class="black-text" *ngIf="totalElements > 0">{{ totalElements }} ordens encontradas</span>

              <div class="search-container">
                <input type="text" placeholder="Pesquisar" class="search-input" [(ngModel)]="searchText"
                  (ngModelChange)="onSearchChange($event)" />
                <img class="search-icon" src="assets/image/search.svg" />
              </div>
            </div>

            <ng-container *ngIf="filteredItems.length > 0 && !loading">
              <div class="row items-list align-items-center">
                <div class="col-md-2">Número</div>
                <div class="col-md-4">Status</div>
                <div class="col-md-2">Data</div>
                <div class="col-md-4"></div>
              </div>

              <div *ngFor="let item of filteredItems" class="row items-list align-items-center">
                <div class="col-md-2">
                  <span *ngIf="item.status === 'Integrated'" (click)="goOrderDetail(item?.order.id)"
                    class="blue-text tappable">{{ item?.externalId }}</span>
                  <span *ngIf="item.status !== 'Integrated'" class="gray-text">{{ item?.externalId }}</span>
                </div>

                <div class="col-md-4 elispis">
                  <span class="danger-text" [title]="item?.errorMessage" *ngIf="item?.errorMessage; else status">
                    {{ item?.errorMessage }}
                  </span>

                  <ng-template #status>
                    <span *ngIf="item.status === 'PendingSeeaway'" class="grey-text">Em fila de processamento</span>
                    <span *ngIf="item.status === 'Integrated'" class="success-text">Integrado</span>
                  </ng-template>
                </div>

                <div class="col-md-2">
                  <span class="grey-text">{{ item?.opDate | date:"dd/MM/yyyy" }}</span>
                </div>
                <div class="col-md-4">
                  <button *ngIf="item.status !== 'Integrated'" [disabled]="item.reprocessing"
                    class="btn-dark-primary-small" (click)="reprocess(item)">
                    <span *ngIf="item.errorMessage">Reprocessar</span>
                    <span *ngIf="!item.errorMessage">Processar</span>
                  </button>

                  <span *ngIf="
                      item.status === 'Integrated' && (
                      !item?.order?.orderSettlement?.exchangeContractFile ||
                      !item?.order?.orderSettlement?.proofOperationFile ||
                      item?.order?.orderSettlement?.orderSettlementAttachments
                        ?.length === 0) ">
                    <button class="btn-dark-primary-small"
                      (click)="openSettlementDocumentsComponentModal(item?.order.id)">
                      <img src="assets/image/clip-icon-white.svg" />
                      Anexar documentos
                    </button>
                  </span>

                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="loading">
              <div class="row not-found align-items-center">
                <span class="spinner-border text-primary"></span>
              </div>
            </ng-container>

            <ng-container *ngIf="filteredItems.length == 0 && !loading">
              <div class="row not-found align-items-center">
                <span class="grey-text">Nenhum boleto encontrado com o número {{searchText}}.</span>
                <br><br><br>
                <button class="btn-dark-primary-small" (click)="import()">Forçar importação do boleto</button>
              </div>
            </ng-container>
          </div>

          <div *ngIf="filteredItems.length > 0 && !loading" class="list-actions page">
            <mat-paginator class="custom-paginator" [pageIndex]="pageNumber" [pageSize]="pageSize"
              [length]="totalElements" (page)="onChangePage($event)" [pageSizeOptions]="[5, 10, 25, 50]"
              showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>